module.exports = __webpack_public_path__ + "img/slogan.0e65d77a.png";